import {https,httpsFile} from './http';
export function show(id){
    return httpsFile().get(`/wholesale-discounts/${id}`);
}

export function update(id,data){
    return httpsFile().post(`/wholesale-discounts/${id}`,data) ;
}